import { render } from "./breadcrumbsApp.vue?vue&type=template&id=1e06c5ba&scoped=true"
import script from "./breadcrumbsApp.vue?vue&type=script&lang=js"
export * from "./breadcrumbsApp.vue?vue&type=script&lang=js"

import "./breadcrumbsApp.vue?vue&type=style&index=0&id=1e06c5ba&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e06c5ba"]])

export default __exports__